import { Component, inject } from "@angular/core";
import { CardModalService } from "@shared/card-modal";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-ifirmtaxprep-north-panel",
    imports: [JumpstartComponentsModule],
    templateUrl: "./ifirmtaxprep-north-panel.component.html",
    host: { class: "wk-cm__tags" },
})
export class IfirmtaxprepNorthPanelComponent {
    public readonly cardModalService = inject(CardModalService);
}
